import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./language.css";
import { setBackButtonUrl } from "../uiSlice";
import { writePlayerLanguage } from "../gameSetupStorage";
import { getThemeButtonGradient } from "../../functions/themeAssets";

const LANGS = [
  { id: "english", label: "English", bg: "#0b74b0" },
  { id: "marathi", label: "मराठी", bg: "#75479c" },
  { id: "hindi", label: "हिंदी", bg: "#bd3861" },
];

export default function LanguageSelect() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((s) => s.auth);
  const { data: themeData } = useSelector((s) => s.theme);
  const [selected, setSelected] = useState("");

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch, user]);

  const { start, end } = getThemeButtonGradient(themeData || {});
  const btnStyle = {
    background: start && end ? `linear-gradient(135deg, ${start}, ${end})` : start || "#e25569",
    color: String(themeData?.button_Textcolor || themeData?.button_text_color || "#fff").trim(),
  };

  const goNext = () => {
    if (!selected) {
      Swal.fire("Please select your language!", "", "info");
      return;
    }
    writePlayerLanguage(selected);
    navigate("/rules", { replace: true });
  };

  return (
    <div className="sl-lang-page">
      <h1 className="sl-lang-title">SELECT YOUR LANGUAGE</h1>
      <p className="sl-lang-sub">भाषा निवडा | भाषा चुने</p>
      <div className="sl-lang-row">
        {LANGS.map((lang) => (
          <button
            key={lang.id}
            type="button"
            className={`sl-lang-card${selected === lang.id ? " is-selected" : ""}`}
            style={{ backgroundColor: lang.bg }}
            onClick={() => setSelected(lang.id)}
          >
            {lang.label}
          </button>
        ))}
      </div>
      <button type="button" className="sl-lang-next" style={btnStyle} onClick={goNext}>
        Next
      </button>
      <div className="sl-rotate-overlay" aria-hidden>
        Please rotate your device for the best experience
      </div>
    </div>
  );
}
